export type AlertIconsSize = 'sm' | 'md' | 'lg'

type Palette = {
  bg: string
  icon: string
}

const BASE = {
  diameter: 32,
  overlap: 1,
  iconSize: 20,
}

const SIZE_CONFIG: Record<AlertIconsSize, typeof BASE> = {
  sm: BASE,
  md: BASE,
  lg: BASE,
}

export const alertIconsRowStyles = {
  root: () => ({
    display: 'flex',
    alignItems: 'center',
  }),

  container: (index: number) => {
    const { overlap } = BASE

    return {
      cursor: 'pointer',
      marginLeft: index === 0 ? 0 : -overlap,
      '@media (hover: hover)': {
        '&:hover > *': {
          transform: 'translateY(-8px)',
          transition: '150ms',
        },
      },
    }
  },

  chip: (palette: Palette, index: number, size: AlertIconsSize) => {
    const { diameter, iconSize } = SIZE_CONFIG[size]

    return {
      width: diameter,
      height: diameter,
      borderRadius: '50%',
      backgroundColor: palette.bg,
      border: '3px solid',
      borderColor: 'surface.default',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      flexShrink: 0,

      cursor: 'pointer',

      zIndex: index + 1,

      '& svg': {
        width: iconSize,
        height: iconSize,
        color: palette.icon,
      },
    }
  },

  tooltip: {
    bgcolor: 'transparent',
    padding: 0,
    maxWidth: 'none',
  },
}
